export default __webpack_public_path__ + "static/media/POLIMOLDES.e671181e.png";